
import './scrutinizer/registrationScrutiny.css'
import usericon from '../../images/user-icon.png'
import { useNavigate } from "react-router-dom";

import jwt from 'jwt-decode';
import { GET_MAPPING_DETAILS, GET_USER_DETAILS, GET_ALL_STAKEHOLDERS, STAKEHOLDER_COUNT } from '../../common/URLs';
import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import { OTPValidationPopover } from '../../preregcamps/confirmPopover/otpValidationPopover';
import { confirmAlert } from 'react-confirm-alert';
import { DialogContent, Dialog, IconButton, Tooltip } from '@mui/material';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { PROD } from '../../common/constants';
import { Box, CardContent, Card, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { loaderService } from '../../common/custom-loader/loader-service';
import { lastFiveDigitsComparator } from '../../common/commonFunction';
import { HowToRegIcon } from '../../common/icons';
import apiClient from '../../axios';

function RegistrationNew() {
    const [emailId, setEmailId] = useState();
    const [userId, setUserId] = useState();
    const [userDetails, setUserDetails] = useState();
    const [mappingDetails, setMappingDetails] = useState();
    const [stakeHolders, setStakeHolders] = useState();
    const [stakeHolderSubCategory, setStakeHolderSubCategory] = useState();
    const [stakeholderType, setStakeholderType] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [urn, setUrn] = useState();
    const [mobileNumber, setMobileNumber] = useState();
    const [editMode, setEditMode] = useState();
    
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
        }
    }, [getLocalStorageItem('id_token')]);
    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const email = decoded.emails?.[0];
            setEmailId(email);

        }
    }, [getLocalStorageItem('id_token')]);
    useEffect(() => {
        if (emailId) {
            getUserDetails();
        }
    }, [emailId]);
    const onRegister = (urn1, mobileNumber, subCategory, stakeHolderType, editmode) => {
        setStakeHolderSubCategory(subCategory);
        setStakeholderType(stakeHolderType);
        setUrn(urn1);
        setMobileNumber(mobileNumber);
        setEditMode(editmode);
        //handleLogModalOpen();

        if (subCategory == "Grower" || subCategory == "Individual" || subCategory == "JFMC" || subCategory === "Other Agency") {
            navigate("/registrationHome/registration/registrationDetails", { state: { URN: urn1, editmode: editmode } });
        }
        else if (subCategory == "Forest") {
            navigate("/registrationHome/registration/personalDetailsForest", { state: { URN: urn1, editmode: editmode } })
        } else if (subCategory === "Co-operative" || subCategory === "FPO" || subCategory === "SHG" || subCategory === "FPC") {
            navigate("/registrationHome/registration/registrationMemberDetails", { state: { URN: urn1, stakeHolderSubCategory: subCategory, editmode: editmode } })
        }
        else if (stakeholderType === "HIT") {
            navigate("/hitRegistration", { state: { URN: urn1 } })
        }
        else if (stakeholderType === "Transporter") {
            navigate("/hitRegistration", { state: { URN: urn1 } })
        }
        else if (stakeholderType === "LLE") {
            navigate("/lleMainPage", { state: { URN: urn1 } })
        }
        else if (stakeholderType === "Interim Storage Operator") {
            navigate("/hitRegistration", { state: { URN: urn1 } })
        }
    }
    const onOTPValidated = (urn1,onClose) => {
        onClose();
        if (stakeHolderSubCategory == "Grower" || stakeHolderSubCategory == "Individual" || stakeHolderSubCategory == "JFMC" || stakeHolderSubCategory === "Other Agency") {
            navigate("/registrationHome/registration/registrationDetails", { state: { URN: urn1, editmode: editMode, registerByScruOtpValidated: true  } });
        }
        else if (stakeHolderSubCategory == "Forest") {
            navigate("/registrationHome/registration/registrationDetailsForest", { state: { URN: urn1, editmode: editMode } })
        } else if (stakeHolderSubCategory === "Co-operative" || stakeHolderSubCategory === "FPO" || stakeHolderSubCategory === "SHG" || stakeHolderSubCategory === "FPC") {
            navigate("/registrationHome/registration/registrationMemberDetails", { state: { URN: urn1, stakeHolderSubCategory: stakeHolderSubCategory, editmode: editMode } })
        }
        else if (stakeholderType === "HIT") {
            navigate("/hitRegistration", { state: { URN: urn1 } })
        }
        else if (stakeholderType === "Transporter") {
            navigate("/hitRegistration", { state: { URN: urn1 } })
        }
        else if (stakeholderType === "LLE") {
            navigate("/lleMainPage", { state: { URN: urn1 } })
        }
        else if (stakeholderType === "Interim Storage Operator") {
            navigate("/hitRegistration", { state: { URN: urn1 } })
        }
    }
    useEffect(() => {
        if (userDetails) {
            const role = userDetails.user.userRoles?.[0].roleName;
            const userid = userDetails.user.id;
            setUserId(userid);
        }
    }, [userDetails]);
    useEffect(() => {
        if (userId) {
            getMappingDetails();
        }
    }, [userId]);
    function getUserDetails() {
        loaderService.showLoader()
        apiClient
            .post(GET_USER_DETAILS,
                {
                    "emailAddress": emailId,
                    "userRole": localStorage.getItem('role'),
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetails(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                loaderService.hideLoader();
            });
    }
    const pendingAppCount = userDetails?.applicationStatusCount?.[0]?.count;
    const pendingClarificationsCount = userDetails?.applicationStatusCount?.[1]?.count;
    function getMappingDetails() {
        loaderService.showLoader()
        apiClient
            .post(GET_MAPPING_DETAILS,
                {
                    "userID": userId,
                    "isScrutinyAction":true,
                    "userRole": localStorage.getItem('role'),
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setMappingDetails(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    const mappingArray = mappingDetails?.scrutinizermappings;

    const columns = [
        {
            field: 'id', headerName: 'S.No', width: 60,
            renderCell: (index) => index.api.getRowIndex(index.row.urn) + 1
        },
        { field: 'urn', headerName: 'URN', width: 200,
        sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
        { field: 'stakeholderName', headerName: 'Stakeholder Name', width: 200 },
        { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 200 },
        { field: 'curentOwner', headerName: 'Current Owner', width: 200 },
        { field: 'lastUpdatedDate', headerName: 'Last Updated Date', width: 200 },
        {
            field: 'isRegistered', headerName: 'Reg. Completed', width: 200,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Yes';
                }
                else {
                    return 'No';
                }
            }
        },
        { field: 'status', headerName: 'Status', width: 200 },
        { field: 'scutinyStatus', headerName: 'Scrutiny Status', width: 200 },
        {
            field: 'action', headerName: 'Action', width: 150,
            renderCell: (params) => {
                return (
                    <Tooltip title="Register">
                        <IconButton 
                        size='large'
                        color="primary"
                         onClick={() => onRegister(params?.row?.urn, params?.row?.mobileNumber, params?.row?.stakeholderSubCategory, params?.row?.stakeholderType, true)}>
                            <HowToRegIcon/>
                            </IconButton>
                            </Tooltip>
                        
                );
            }
        },

    ];


    return (
        <div>
            <Container fluid>
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG63</p>}

                <Row>

                    <Col xs={12} md={12} >
                        <div className='lead-container'>
                            <div className="hitDetailsText">Pending Registrations</div>
                            {mappingArray &&
                                <Box style={{ height: 500, width: '100%' }}>
                                    <DataGrid
                                        rows={mappingArray}
                                        columns={columns}
                                        pageSize={10}
                                        getRowId={(row) => row?.urn}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                    />
                                </Box>}
                            
                        </div>
                    </Col>
                </Row>
            </Container>
            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <OTPValidationPopover onClose={handleLogModalClose} urn={urn} mobileNumber={mobileNumber} callback={onOTPValidated} />
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default RegistrationNew;
